import { useContext } from "react";
import axios, { AxiosRequestConfig, HttpStatusCode } from "axios";
import AuthContext from "common/store/AuthContext";

import { genApiDatePath, generateErrorMsg, getServerUrl } from "utils/commonTools";
import { createFileNameDate } from "utils/DateTools";
import { useGetPrint } from "./useGetPrint";
import { getPrintResult } from "../types/getPrintResult";
import { EVENT_TYPE } from "pages/parkevents/types/EVENT_TYPE";

//--------------------------------------
// 事業情報の印刷
//--------------------------------------
export const useEventReport = () => {
  const authCtxt = useContext(AuthContext);
  const { token } = authCtxt;

  const { initiateDownload } = useGetPrint();

  const getEventReort = async (
    date: Date,
    eventType: EVENT_TYPE,
    tabTitle: string,
    eventTitle: string,
    eventCategoryId?: number // 事業の詳細分割
  ): Promise<getPrintResult> => {
    const config = {
      headers: { "Content-type": "application/json", Authorization: `Bearer ${token}` },
      responseType: "blob",
      params: {
        title: eventTitle,
        eventCategoryId,
      },
    } as AxiosRequestConfig;

    const parkId = authCtxt.selectedPark?.parkId;
    const parkName = authCtxt.selectedPark?.parkName;

    try {
      const response = await axios.get(
        getServerUrl() + `print/events/${parkId}/${eventType}/${genApiDatePath(date)}`,
        config
      );
      if (response.status === HttpStatusCode.NoContent) {
        return {
          succeeded: false,
          msg: "レポートを生成できませんでした（帳票が未登録です）",
        };
      }
      const url = window.URL.createObjectURL(response.data);

      const fileName = `${tabTitle}_${eventTitle}_${parkName}_${createFileNameDate(date)}.xlsx`;
      initiateDownload(url, fileName);
      return { succeeded: true, msg: "" };
    } catch (error) {
      var errMsg = generateErrorMsg(error);
      return { succeeded: false, msg: errMsg };
    }
  };

  return { getEventReort };
};
